import { useMemo } from 'react';
import useBookingBill from '@/features/dashboard/bookingChanges/hooks/useBookingBill.ts';
import useGetOpenDraft from '@/features/dashboard/bookingChanges/hooks/useGetOpenDraft.ts';
import useChangePackageNumber from '@/features/dashboard/bookingChanges/hooks/useChangePackageNumber.ts';
import useChangePreview from '@/features/dashboard/bookingChanges/hooks/useChangePreview.ts';
import { bookingChangeDetailMapper } from '@/features/dashboard/bookingChanges/types/BookingChangeDetailDto.mapper.ts';
import { ChangePackageSummaryVm } from '@/features/dashboard/bookingChanges/types/ChangePackageFlowViewModel.ts';

/** Krok W1 — podsumowanie zmian zebranych pod osobami. */
const useChangePackageSummary = (bookingId: string | undefined) => {
  const billQuery = useBookingBill(bookingId);
  const draftQuery = useGetOpenDraft(bookingId);
  const packageNumberQuery = useChangePackageNumber(
    bookingId,
    draftQuery.data?.id,
  );
  const previewQuery = useChangePreview(bookingId);
  const { packageNumber } = packageNumberQuery;

  const summary: ChangePackageSummaryVm | null = useMemo(() => {
    const change = draftQuery.data;
    // Nagłówek kroku mówi „Paczka #13”, więc bez numeru nie ma czego pokazać —
    // ekran czeka na listę paczek, zamiast podstawiać liczbę zastępczą.
    if (!billQuery.data || !change || packageNumber === null) {
      return null;
    }
    return bookingChangeDetailMapper.toSummaryVm(
      change,
      billQuery.data,
      packageNumber,
      previewQuery.preview,
    );
  }, [billQuery.data, draftQuery.data, packageNumber, previewQuery.preview]);

  return {
    summary,
    isLoading:
      billQuery.isLoading ||
      draftQuery.isLoading ||
      packageNumberQuery.isLoading ||
      previewQuery.isLoading,
    isError: billQuery.isError || draftQuery.isError,
    error: previewQuery.error,
  };
};

export default useChangePackageSummary;
